import {useMutation,} from 'react-query'
import service from '../../services'

export default function useSalesforceUsernamePasswordAuth() {
    return useMutation((params: any) => service.salesforceAuth().salesforceAuthUsernamePassword(params).then((e: any) => e?.data))
}